import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { CanComponentDeactivate } from './can-deactivate.interface';
import { ModalService } from '../services/modal.service';
import { Observable, of, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  if (!component || !component.canDeactivate) {
    return true;
  }

  const canDeactivate = component.canDeactivate();
  
  if (typeof canDeactivate === 'boolean') {
    if (!canDeactivate) {
      // Se ritorna false, apri la modale di conferma
      const modalService = inject(ModalService);
      return modalService.openConfirm({
        title: 'Modifiche non salvate',
        message: 'Hai delle modifiche non salvate. Sei sicuro di voler uscire? Le modifiche andranno perse.',
        yesText: 'Esci senza salvare',
        noText: 'Annulla'
      });
    }
    return canDeactivate;
  }

  // Se è una Promise, convertila in Observable
  if (canDeactivate instanceof Promise) {
    return from(canDeactivate).pipe(
      switchMap((result) => {
        if (!result) {
          const modalService = inject(ModalService);
          return modalService.openConfirm({
            title: 'Modifiche non salvate',
            message: 'Hai delle modifiche non salvate. Sei sicuro di voler uscire? Le modifiche andranno perse.',
            yesText: 'Esci senza salvare',
            noText: 'Annulla'
          });
        }
        return of(result);
      })
    );
  }

  // Se è già un Observable, gestiscilo direttamente
  if (canDeactivate instanceof Observable) {
    return canDeactivate.pipe(
      switchMap((result) => {
        if (result === false) {
          const modalService = inject(ModalService);
          return modalService.openConfirm({
            title: 'Modifiche non salvate',
            message: 'Hai delle modifiche non salvate. Sei sicuro di voler uscire? Le modifiche andranno perse.',
            yesText: 'Esci senza salvare',
            noText: 'Annulla'
          });
        }
        return of(result);
      })
    );
  }

  return canDeactivate;
};

